import YearView from './calendar/year-view';
import FoodCalendarTitle from './calendar/food-calendar-title';
import { useEffect } from 'react';
import { endOfYear, startOfYear } from 'date-fns';
import { getFoodLogsMin } from '../../data/food-data-service';
import { createFoodCalendar } from '../../domain/food-calendar-provider';
import { useFoodStore } from '../../data/food-store';
import DayMetadataPopup from './calendar/day/day-metadata-popup';

const FoodCalendarHome = () => {

    const currentCalendarYear = useFoodStore(store => store.currentCalendarYear);
    const dayPopupMetadata = useFoodStore(store => store.dayPopupMetadata);
    const setDayPopupMetadata = useFoodStore(store => store.setDayPopupMetadata);
    const foodCalendarData = useFoodStore(store => store.foodCalendarData);
    const setFoodCalendarData = useFoodStore(store => store.setFoodCalendarData);

    useEffect(() => {

        (async () => {
            const date = new Date(currentCalendarYear, 0, 1); // January is 0

            const fromDate = startOfYear(date).getTime();
            const toDate = endOfYear(date).getTime();
            const data = await getFoodLogsMin(fromDate, toDate);

            const result = createFoodCalendar(date.getFullYear(), data);
            setFoodCalendarData(result);
        })();

    }, [currentCalendarYear, setFoodCalendarData]);

    const onDayMetadataPopupClose = () => {
        setDayPopupMetadata(null);
    };

    return (
        <div className="max-w-full mx-auto py-4">

            {
                foodCalendarData &&
                <>
                    <FoodCalendarTitle />
                    <YearView />
                </>
            }

            {
                dayPopupMetadata &&
                <DayMetadataPopup onClose={ onDayMetadataPopupClose } />
            }
        </div>
    )
};

export default FoodCalendarHome;